import * as t from 'io-ts';

const ApplicationStatusResponse = t.type({
  version: t.string,
  isBeta: t.boolean,
}, 'ApplicationStatusResponse');

type ApplicationStatusResponse = t.TypeOf<typeof ApplicationStatusResponse>;
export { ApplicationStatusResponse };
